import { Component, OnInit, ViewChild } from "@angular/core";
import { MatSort, MatTableDataSource } from "@angular/material";
import { DRenta210IngresoServicios } from "@dian-api/renta210-ingreso";
import { DContextoMuisca, DError, DRespuestaSimple } from "@dian/core";
import { DListaDocumentos, DInfoResumenFormulario } from "@dian/api-formulario";
import { DNotificacionServicio } from "@dian-cmp/notificaciones";
import { MatDialog } from "@angular/material";
import { GeneralService } from "../../services/general.service";
import { DIdentificadorDocumento } from "../identificadorDocumento/didentificador-documento";
import { DMensajes, DOperacionesGeneralesIngresoServicio } from "@dian-cmp/formulario";
import { InfoFormularios } from "../models/infoFormularios";
import { DLiquidacionRecibo, DRtaLiquidacionReciboPago } from "@dian-api/recibo-pago490";
import { DEnvioDataServicio } from "@dian-cmp/recibo-pago";
import { DatePipe } from "@angular/common";
import { Observable } from "rxjs";
import { ModoDiligenciemientoComponent } from "../shared/modals/modo-diligenciemiento/modo-diligenciemiento.component";
import { ModalService, ModalType } from "../../modal/services/modal.service";

@Component({
  selector: "app-presentados",
  templateUrl: "./presentados.component.html",
  styleUrls: ["./presentados.component.css"],
  providers: [DRenta210IngresoServicios],
})
export class PresentadosComponent implements OnInit {
  displayedColumns = [
    "num_formulario",
    "anio_frecuencia",
    "concepto",
    "fecha_presentacion",
    "acciones",
  ];
  dataPresentados: InfoFormularios[] = [];
  arrDocumentosPresentados: DListaDocumentos;
  dataTable: InfoFormularios[] = [];
  datosUsuario: DContextoMuisca;

  dataSource = new MatTableDataSource(this.dataTable);
  private arrencabezadoPieForm: Array<DIdentificadorDocumento>;
  private arrDocumentosFactura: DListaDocumentos;
  private estadosCarga = {
    pendientes: false,
    presentados: false,
    definitivos: false,
    anios: false,
  };
  private operacionesGenerales: DOperacionesGeneralesIngresoServicio;
  private tiempo: Date;
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }
  tabs: any = {
    generarRecibo: {value: true, title: 'Generar Recibo'},
    previsualizar: {value: false, title: 'Previsualizar'},
    datosPago: {value: false, title: 'Datos de pago'},
  }
  currentTab = this.tabs.generarRecibo;
  contexto : DContextoMuisca;
  fecha: string;
  liquidacion: DLiquidacionRecibo;
  mensajeAntesGuardar: string;
  pagoPSE: boolean;
  tieneFirmaElectronica: boolean;
  pagando = false;
  formulario490 = new DRtaLiquidacionReciboPago;
  fechaPago = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
  fechaHoy: Date = new Date();
  listCuotas: number[] = [];
  identificadoresDocumentos : any;


  constructor(
    private generalService: GeneralService,
    private dServicioRESTAPI: DRenta210IngresoServicios,
    private dNotificacionServicio: DNotificacionServicio,
    private dialog: MatDialog,
    private denvioData: DEnvioDataServicio,
    private datePipe: DatePipe,
    private modalService: ModalService,
  ) {
    this.generalService.datosRespuesta$.subscribe((res) => {
      this.datosUsuario = res;
    });
    this.operacionesGenerales = new DOperacionesGeneralesIngresoServicio(
      this.dNotificacionServicio,
      this.dServicioRESTAPI,
      this.dialog
    );
    this.denvioData.cambiaFlujo$.subscribe(data => {
      this.changeTab(data);
    })

    this.denvioData.reciboPago$.subscribe(res => {
      this.formulario490 = res ;
    })
    this.arrDocumentosPresentados = new DListaDocumentos();

    this.tiempo = new Date();
    let tiempoReal = new Date();
    setInterval(() => {
      tiempoReal.setSeconds(tiempoReal.getSeconds() + 1);
      this.tiempo = new Date(tiempoReal);
    }, 1000);
    this.obtenerDocsPresentados();
  }

  ngOnInit() {
    if (!this.datosUsuario) {
      this.datosUsuario = this.generalService.getDatosUsuario();
    }
    

    /*  console.log(this.arrDocumentosPresentados) */
  }

  buildCuotas() {
    if (Number(this.liquidacion.totalCuotas) > 1) {
        for (let i = 1; i <= Number(this.liquidacion.totalCuotas); i++) {
          this.listCuotas.push(i);
        }
    }
  }

  sendCuota() {
    this.denvioData.enviarNumeroCuota(this.liquidacion.numCuota);
  }

  ngAfterViewInit() {
    //this.dataSource.sort = this.sort;
  }

  /**
   * @desc Funcion para obtener los documentos Presentados
   */
  public obtenerDocsPresentados() {
    let precarga = this.dNotificacionServicio.mostrarDialogoCarga();

    let observablePresentados =
      this.dServicioRESTAPI.consultarFormulariosEstado("presentado");
    observablePresentados
      /*  .pipe(tap((res)=>{
      console.log("Tap ", res)
      this.dataPresentados = res.listadoFormularios.infoFormularios;
      console.log(this.dataPresentados)
    })) */
      .subscribe(
        (res) => {
          this.dataPresentados = res.listadoFormularios; //.infoFormularios; //<DListaDocumentos>(res.infoFormularios);
          this.identificadoresDocumentos = res.idetificadoresDocumentos;
          this.dataTable = res.listadoFormularios.infoFormularios;
          this.dataSource = new MatTableDataSource(
            this.dataPresentados["infoFormularios"]
          );
          this.dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
              case "num_formulario":
                return item["identificador"].id;
              case "fecha_presentacion":
                return item["fecPresentacion"];
              case "concepto":
                const modo =
                  item["modo"] === "fraccion_correccion"
                    ? "Corrección fraccion"
                    : item["modo"];
                return modo;
              case "anio_frecuencia":
                return item["anio"];

              default:
                return item[property];
            }
          };

          this.arrencabezadoPieForm = res.idetificadoresDocumentos;
          // Array<DIdentificadorDocumento>(res.idetificadoresDocumentos);
          this.arrDocumentosFactura = <DListaDocumentos>(
            JSON.parse(JSON.stringify(this.dataPresentados))
          );
          // let identificadorDoc:DIdentificadorDocumento=new DIdentificadorDocumento();
          for (let identificadorDoc of Array(this.arrencabezadoPieForm)) {
            //let lidentificador:DIdentificadorDocumento =<DIdentificadorDocumento>identificadorDoc;
            //let lidentificador =identificadorDoc;
            let contador = 0;
            //this.logger.info("Tamaño de los identificadores del documento ",(Array)(identificadorDoc.links).length);
            for (let lidentificador1 of identificadorDoc) {
              let claveNegocio: string = lidentificador1.cadClaveNegocio;
              let ideDocumento = lidentificador1.idDocumento;
              let valoresCasilla: string[] = claveNegocio.split(";");
              let casilla285 = valoresCasilla[3].split("=");
              if (casilla285[0] == "285") {
                let valcasilla285: string = casilla285[1];
                //let valcasilla285:string='false';
                if (valcasilla285 == "true") {
                  let count = 0;
                  for (let ldocumento of this.dataPresentados[
                    "infoFormularios"
                  ]) {
                    if (ideDocumento == ldocumento.identificador.id) {
                          this.dataPresentados[
                        "infoFormularios"
                      ].splice(
                        count,
                        1
                      );  
                      break;
                    }
                    count++;
                  }
                } else {
                  let count = 0;
                  for (let ldocumento of this.arrDocumentosFactura
                    .infoFormularios) {
                    if (ideDocumento == ldocumento.identificador.id) {
                      this.arrDocumentosFactura.infoFormularios.splice(
                        count,
                        1
                      );
                      break;
                    }
                    count++;
                  }
                }
              } else {
                let count = 0;
                for (let ldocumento of this.arrDocumentosFactura
                  .infoFormularios) {
                  if (ideDocumento == ldocumento.identificador.id) {
                    this.arrDocumentosFactura.infoFormularios.splice(count, 1);
                    break;
                  }
                  count++;
                }
              }
              contador++;
            }
          }
          this.estadosCarga.presentados = true;
          precarga.close();
        },
        (error) => {
          this.estadosCarga.presentados = true;
          precarga.close();
        }
      );
  }

  /**
   * @desc Funcion para imprimir el formulario
   */
  imprimirFormulario(idFormulario: string) {
    this.operacionesGenerales.imprimirFormulario(idFormulario);
  }

  /**
   * @description Funcion para consumir servicio y conectar con componente contenedor que lleva la logica
   * @param objetoFormulario
   */
  corregirFormulario(objetoFormulario: DInfoResumenFormulario) {
   /////////////////Habilitar no experto = 2022 y 2023
   if (objetoFormulario && (objetoFormulario.anio === 2022 || objetoFormulario.anio === 2023) && (objetoFormulario.modo !== 'fraccion' && objetoFormulario.modo !== 'fraccion_correccion')) {
      let config = {
        disableClose: true,
        maxWidth: '400px',
        data: {}
      };
      let dialogRef = this.dialog.open(ModoDiligenciemientoComponent, config);
      dialogRef.afterClosed().subscribe(result => {
        if (result) {

          const tmpFormulario = this.identificadoresDocumentos.find((item => `${item.idDocumento}` === `${objetoFormulario.identificador.id}`));
          if (tmpFormulario) {
            const cadClaveNegocio = tmpFormulario.cadClaveNegocio.split(';').filter(elemento => elemento.trim() !== '').find(elemento => elemento.includes('336'));
            const claveNegocio336 = (cadClaveNegocio && cadClaveNegocio.split('=')[1] && cadClaveNegocio.split('=')[1] !== '0') ? cadClaveNegocio.split('=')[1] : '16500002';
            const modoDiligenciamientoDominio = result === 'noExperto' ? '16500003' : '16500002';
            objetoFormulario['modoNoExperto'] = result === 'noExperto' ? true : false;
            claveNegocio336 === modoDiligenciamientoDominio ? this.generalService.enviarCorregirFormulario(objetoFormulario) : this.mostrarDialogoCambioModoDiligenciamiento(objetoFormulario);
          } else {
            objetoFormulario['modoNoExperto'] = result === 'noExperto' ? true : false;
          console.log('obj: ', objetoFormulario);
          this.generalService.enviarCorregirFormulario(objetoFormulario);
          }
        }
      });
    }else{
      this.generalService.enviarCorregirFormulario(objetoFormulario);
    }
  }

  mostrarDialogoCambioModoDiligenciamiento(objFormulario: DInfoResumenFormulario) {
    const configBody = {
      title: 'Advertencia',
      message: 'Usted va a cambiar el modo de diligenciamiento, ¿Está seguro que desea continuar?',
      main_button: "Aceptar",
      secondary_button: "Cancelar",
      onMainAction: ()=>{this.generalService.enviarCorregirFormulario(objFormulario);}
     }
     this.modalService.show(ModalType.INFO, configBody);
  }

  pagarFormulario(id, anio, periodo, modo, item) {
    const data = {
      id: id,
      anio: anio,
      periodo: periodo,
      modo: modo,
      item: item,
    };
    this.generalService.enviarPagarFormulario(data);
    this.generalService.datosReciboPago$.subscribe(data => {
      this.contexto = data.contexto;
      this.fecha = data.fecha;
      this.liquidacion = data.liquidacion;
      this.mensajeAntesGuardar = data.mensajeAntesGuardar;
      this.pagoPSE = data.pagoPSE;
      this.tieneFirmaElectronica = data.tieneFirmaElectronica;
      this.pagando = true;
      if (this.liquidacion && parseInt(this.liquidacion.totalCuotas) > 1) {
        this.buildCuotas();
      }
    })
  }

  changeTab(tab: string) {
    const keys = Object.keys(this.tabs);
    keys.forEach(key => {
       this.tabs[key].value = false;
    })
    keys.forEach(key => {
      if (key === tab) {
        this.tabs[key].value = true;
        this.currentTab = this.tabs[key];
      }
    })
  }
  
  salirDePago(){
    this.pagando = false;
  }

  sendDate(){
    this.denvioData.enviarFechaPago(this.fechaPago);
  }
}



// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/components/presentados/presentados.component.ts